// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3wKB8","info":"Note_info__3qJNS","note":"Note_note__1hSm2","actions":"Note_actions__17eO1"};